import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import AccessRightService from "../services/AccessRightService";
import BrandService from "../services/BrandService";
import { useBrand } from "./../helper/BrandContext";

const Navbar = ({ isLoggedIn, setIsLoggedIn }) => {
  const [menuItems, setMenuItems] = useState([]);
  const userService = new AccessRightService();
  const [brands, setBrands] = useState([]);
  const brandService = new BrandService();

  const { brand, setBrand } = useBrand();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const fetchBrands = async () => {
    try {
      const data = await brandService.GetBrandsDDL();
      if (data.responseCode === "200") {
        setBrands(data.responseData);
      }
    } catch (error) {
      console.error("Error fetching brand list:", error);
    }
  };

  const getMenu = () => {
    const userId = sessionStorage.getItem("userId");
    userService.getUserMenu(userId).then((data) => {
      if (data.responseCode === "200") {
        const arraydata = data.responseData;
        let arryFinal = [];

        if (arraydata != null) {
          arraydata.forEach((element) => {
            let contents = {};
            let obj = {};
            element.content.forEach((econ) => {
              obj.label = econ.name;
              obj.icon = econ.icon;
              obj.url = econ.to;

              if (econ.children != null && econ.children.length > 0) {
                let chlddata = [];
                econ.children.forEach((econchld) => {
                  let ob = {};
                  econchld.content.forEach((element) => {
                    ob.label = element.name;
                    ob.url = element.to;
                  });
                  chlddata.push(ob);
                });
                obj.items = chlddata;
              } else {
              }
              contents = obj;
            });
            arryFinal.push(contents);
          });
          setMenuItems(arryFinal);
        }
      } else {
        //console.log(data.data.responseMessage);
      }
    });
  };

  useEffect(() => {
    if (isLoggedIn) {
      getMenu();
      fetchBrands();
    }
  }, [isLoggedIn]);

  const toggleDropdown = (index) => {
    const updatedMenuItems = menuItems.map((item, i) => {
      if (i === index) {
        return { ...item, showDropdown: !item.showDropdown };
      } else {
        return { ...item, showDropdown: false };
      }
    });
    setMenuItems(updatedMenuItems);
  };

  const toggleSubMenu = (index) => {
    const updatedMenuItems = menuItems.map((item, i) => {
      if (i === index) {
        return { ...item, showDropdown: !item.showDropdown };
      } else {
        return { ...item, showDropdown: false };
      }
    });

    setMenuItems(updatedMenuItems);
  };

  return (
    <>
      <section id="topbar" className="topbar d-flex align-items-center ">
        <div className="container-fluid d-flex justify-content-center justify-content-md-between mobile-view">
          <div className="contact-info d-flex align-items-center contacte ">
            <i className="fa fa-envelope d-flex align-items-center">
              <a href="mailto:indiacustomercare@glanbia.com" target="_blank">
                &nbsp;indiacustomercare@glanbia.com
              </a>
            </i>
            <i className="fa fa-phone d-flex align-items-center">
              <a href="tel:01149594959" target="_blank">
                &nbsp;011 - 49594959
              </a>
            </i>
          </div>
          <div className="social social-links d-none d-md-flex align-items-center mr-3">
            <a href="https://twitter.com/OptimumNutri_IN" className="twitter">
              <i className="fa fa-twitter" />
            </a>
            <a
              href="https://www.facebook.com/OptimumNutritionIN"
              className="facebook"
            >
              <i className="fa fa-facebook" />
            </a>
            <a
              href="https://www.instagram.com/optimumnutri_in/"
              className="instagram"
            >
              <i className="fa fa-instagram" />
            </a>
            <a
              href="https://www.youtube.com/user/OptimumNutriIN"
              className="youtube"
            >
              <i className="fa fa-youtube" />
            </a>
          </div>
        </div>
      </section>

      <nav className="navbar navbar-dark navbar-expand-sm bg-dark">
        <a href="index.html">
          <Link to="/">
            <img src="img/logo.svg" alt="logo" />
          </Link>
        </a>
        <button
          hidden={!menuItems.length > 0}
          className="navbar-toggler"
          data-toggle="collapse"
          data-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
          <span className="menu_icn" style={{ color: "#fff" }}>
            <i className="bi bi-list"></i>
          </span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <ul className="navbar-nav ml-auto">
            <li clas="navbar-item">
              {isLoggedIn &&
                menuItems.map((menuItem, index) => (
                  <div key={index} className="relative inline-block text-left">
                    <button
                      onClick={() => toggleDropdown(index)}
                      className="text-gray-300 hover:bg-gray-700 px-3 py-2 text-sm 
                    font-medium focus:outline-none focus:text-white focus:bg-gray-700 relative z-10"
                    >
                      {menuItem.label === "Dashboard" ? (
                        <Link to="/dashboard">Dashboard</Link>
                      ) : (
                        <span>{menuItem.label}</span>
                      )}
                    </button>
                    {isLoggedIn && menuItem.showDropdown && menuItem.items && (
                      <div
                        className="origin-top-left absolute left-0 mt-2 w-48 shadow-lg 
                    bgwhite ring-1 ring-black ring-opacity-5 z-20"
                      >
                        {menuItem.items.map((subItem, subIndex) => (
                          <Link
                            key={"S" + subIndex}
                            onClick={() => toggleDropdown("S" + subIndex)}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-700"
                            to={subItem.url}
                          >
                            {subItem.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
            </li>
            <li className="nav-item ca login">
              <div className="flex items-center gap-x-4 logoutbtn nav-link">
                {isLoggedIn && (
                  <Link to="/login">
                    <button
                      onClick={() => {
                        sessionStorage.clear();
                        setIsLoggedIn(false);
                      }}
                      className="logibtn"
                    >
                      LOG OUT
                    </button>
                  </Link>
                )}
              </div>
            </li>
            <select
              style={{ height: "30px" }}
              hidden={!isLoggedIn}
              value={brand || ""}
              onChange={(e) => setBrand(e.target.value)}
            >
              <option value="" disabled>
                Select a brand
              </option>
              {brands.map((b) => (
                <option key={b.value} value={b.value}>
                  {b.label}
                </option>
              ))}
            </select>
            <li className="adminuser ml-4">
              <span>{isLoggedIn && sessionStorage.getItem("userName")}</span>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};
export default Navbar;
